import { render, staticRenderFns } from "./invoice-view.vue?vue&type=template&id=da423640&scoped=true&"
import script from "./invoice-view.vue?vue&type=script&lang=js&"
export * from "./invoice-view.vue?vue&type=script&lang=js&"
import style0 from "./invoice-view.vue?vue&type=style&index=0&id=da423640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da423640",
  null
  
)

export default component.exports